import React from "react";
import PropTypes from "prop-types";
import { Menu, Icon, Modal } from "antd";
import { OrderedMap } from "immutable";
import { AuthService, CaseService } from "services";

const MenuItem = (key, value) => {
    if (value.children) {
        return (
            <Menu.SubMenu
                key={key}
                title={
                    <span className={"submenu-title-wrapper"}>
                        {value.icon ? < Icon type={value.icon} /> : null}
                        {value.label}
                    </span>
                }
            >
                {value.children.map(_ => {
                    if(_.children) {
                        return (
                            <Menu.SubMenu
                                key={_.key}
                                title={
                                    <p style={{
                                        color: "rgb(36, 96, 121)"
                                    }} key={_.key}>
                                        {_.icon ? < Icon style={{color: "rgb(36, 96, 121)"}} type={_.icon} /> : null}
                                        {_.label}
                                    </p>
                                }
                            >
                                {_.children.map(_ => 
                                    <Menu.Item key={_.key}>
                                        {_.icon ? < Icon type={_.icon} /> : null}
                                        {_.label}
                                    </Menu.Item>
                                ).toList().toArray()}
                            </Menu.SubMenu>
                        
                        );
                    } else {
                        return (
                            <Menu.Item key={_.key}>
                                {_.icon ? < Icon type={_.icon} /> : null}
                                {_.label}
                            </Menu.Item>
                        );
                    }
                }).toList().toArray()}
            </Menu.SubMenu>);
    }
    return (
        <Menu.Item key={key}>
            {value.icon ? <Icon type={value.icon} /> : null}
            {value.label}
        </Menu.Item>);
};

class HeaderMenu extends React.Component {
    state = {
        visible: false,

    };

    navigate = e => {
        if (e.key === "reset_password") {
            this.props.openResetPasswordModal();
        }
        if (e.key === "logout") {
            this.setState({
                visible: true
            });
        }
        if(e.key === "upload_ledger") {
            this.props.history.push("/app/companies/upload-ledger");
        }
        if (e.key === "reports") {
            this.props.history.push("/app/reports");
        }
        if (e.key === "case_create") {
            this.props.history.push("/app/case/new");
        }
        if (e.key === "decision_dashboard") {
            this.props.history.push("/app/inbox/decision-dashboard");
        }
        if (e.key === "underwriting") {
            this.props.history.push("/app/underwriting/jobs");
        }
        if (e.key === "companies") {
            this.props.history.push("/app/companies/list");
        }
        if (e.key === "company-create") {
            this.props.history.push("/app/companies/create");
        }
        if (e.key === "invoice-for-disbursal") {
            this.props.history.push("/app/companies/invoices/upload");
        }
        if (e.key === "company-list") {
            this.props.history.push("/app/companies");
        }
        if (e.key === "review-invoices") {
            this.props.history.push("/app/companies/invoices/review");
        }
        if (e.key === "data-sync") {
            this.props.history.push("/app/companies/sync/request");
        }
        if(e.key === "lenders") {
            this.props.history.push("/app/lenders");
        }
        if(e.key === "bank_accounts") {
            this.props.history.push("/app/bank-accounts");
        }
        if(e.key === "pskit_courier") {
            this.props.history.push("/app/pskit-courier-details");
        }
        if(e.key === "cibil") {
            this.props.history.push("/app/cibil");
        }
        if(e.key === "payment_program") {
            this.props.history.push("/app/payment-program/?ordering=2");
        }
        if(e.key == "db_onboarding"){
            this.props.history.push("/app/db-onboarding/?stage=DOCS_PENDING");
        }
        if(e.key == "adhoc"){
            this.props.history.push("/app/adhoc");
        }
        if(e.key == "mpa_approval"){
        this.props.history.push('/app/mpa-approval');
        }
        if(e.key == "anchor_onboarding"){
            this.props.history.push("/app/anchor-onboarding/?stage=docs_pending");
        }
    };

    onOkPress = () => {
        this.setState({
            visible: false
        }, () => {
            CaseService.deactivateCaseService();
            this.props.logout();
            AuthService.logout();
            this.props.history.replace("/auth");
        });
    };

    render() {
        const { menuItems, permissions } = this.props;
        let newMenuItems = menuItems;
        let isCaseCreateAllow = permissions && permissions.find((_, k) => k === "page_case_create");
        let isUnderWritingAllowed = permissions && permissions.find((_, k) => k === "page_case_underwriting");
        let isInvoiceReview = permissions && permissions.find((_, k) => k === "page_review_invoices");
        let isCompaniesListing = permissions && permissions.find((_, k) => k === "page_companies_listing");
        let isBankAccountViewable = permissions && permissions.find((_, k) => k === "page_bank_account_management");
        let isLenderSectionViewable = permissions && permissions.find((_, k) => k === "page_lenders_management");
        let isPskitCourierView = permissions && permissions.find((_, k) => k === "page_pskit_courier_details");
        
        if (!isCaseCreateAllow) {
            const items = newMenuItems.getIn(["actions", "children"]);
            newMenuItems = newMenuItems.setIn(
                ["actions", "children"],
                items.filter((_, k) => k !== "case_create")
            );
        }
        if (!isPskitCourierView) {
            const items = newMenuItems.getIn(["actions", "children"]);
            newMenuItems = newMenuItems.setIn(
                ["actions", "children"],
                items.filter((_, k) => k !== "pskit_courier")
            );
        }
        if (!isBankAccountViewable) {
            const items = newMenuItems.getIn(["actions", "children"]);
            newMenuItems = newMenuItems.setIn(
                ["actions", "children"],
                items.filter((_, k) => k !== "bank_accounts")
            );
        }
        if (!isLenderSectionViewable) {
            const items = newMenuItems.getIn(["actions", "children"]);
            newMenuItems = newMenuItems.setIn(
                ["actions", "children"],
                items.filter((_, k) => k !== "lenders")
            );
        }
        if (!isUnderWritingAllowed) {
            const items = newMenuItems.getIn(["actions", "children"]);
            newMenuItems = newMenuItems.setIn(
                ["actions", "children"],
                items.filter((_, k) => k !== "underwriting")
            );
        }
        if(!isCompaniesListing) {
            const items = newMenuItems.getIn(["actions", "children", "companies", "children"]);
            newMenuItems = newMenuItems.setIn(
                ["actions", "children", "companies", "children"],
                items.filter((_, k) => k !== "company-list")
            );
        }
        if(!isInvoiceReview) {
            const items = newMenuItems.getIn(["actions", "children", "companies", "children"]);
            newMenuItems = newMenuItems.setIn(
                ["actions", "children", "companies", "children"],
                items.filter((_, k) => k !== "review-invoices")
            );
        }

        if(this.props.isDistributorRM) {
            if (this.props.permissions.get("page_dbt_bulk_assign") || this.props.permissions.get("page_dbt_edit")){
                newMenuItems = newMenuItems.setIn(
                    ["actions", "children"],
                    new OrderedMap({
                        "data-sync": {
                            key: "data-sync",
                            icon: "sync",
                            label: "Data Sync Request",
                            permission: "page_data_sync_requests"
                        }, payment_program: {
                            icon: "file",
                            key: "payment_program",
                            label: "Payment Program",
                            permission: "page_payment_program"

                        }, logout: {
                            icon: "logout",
                            key: "logout",
                            label: "Logout"
                        }
                    })
                );
            }else{
                newMenuItems = newMenuItems.setIn(
                    ["actions", "children"],
                    new OrderedMap({"data-sync": {
                        key: "data-sync",
                        icon: "sync",
                        label: "Data Sync Request",
                        permission: "page_data_sync_requests"
                    }, logout: {
                        icon: "logout",
                        key: "logout",
                        label: "Logout"
                    }})
                );
            }
        }

        return (
            <React.Fragment>
                <Modal
                    closable={true}
                    visible={this.state.visible}
                    onOk={this.onOkPress}
                    onCancel={() => this.setState({
                        visible: false
                    })}
                >
                    {"Please confirm to logout?"}
                </Modal>
                <Menu
                    className={"los-header-menu"}
                    theme={"dark"}
                    selectedKeys={[this.props.location.pathname]}
                    onClick={this.navigate}
                    mode="horizontal">
                    <Menu.Item key={"userName"}>
                        {this.props.userName}
                    </Menu.Item>
                    {newMenuItems
                        .map((value, key) => MenuItem(key, value))
                        .toList()
                        .toArray()}
                </Menu>
            </React.Fragment>
        );
    }
}

HeaderMenu.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    match: PropTypes.object,
    menuItems: PropTypes.object,
    logout: PropTypes.func,
    openResetPasswordModal: PropTypes.func,
    permissions: PropTypes.object,
    userName: PropTypes.string,
    isDistributorRM: PropTypes.bool
};

export default HeaderMenu;
